import IStatusColor from "./status-color";
import { IMoveTrackerStatus } from "@nkr/models/index";
import IStep from "./step";

export const Helper = {
    getStatusColor: (status: number, isComplete: boolean): IStatusColor => {
        const green = "#559b5a";
        const red = "#c60d09";
        const yellow = "#f2dd3e";

        var fillColor = "#ddd";
        var badgeColor = "#ddd";
        var textColor = "black";

        switch (status) {
            case 0:
                break;

            case 1:
                fillColor = green;
                textColor = "white";
                badgeColor = green;

                break;

            case 2:
                if (!isComplete) {
                    fillColor = yellow;
                } else {
                    fillColor = green;
                    badgeColor = yellow;
                }

                break;

            case 3:
                if (!isComplete) {
                    fillColor = red;
                } else {
                    fillColor = green;
                    badgeColor = red;
                    textColor = "white";
                }

                break;

            default:
                fillColor = green;
                textColor = "white";
                badgeColor = "";
        }

        return { fillColor, textColor, badgeColor };
    },

    getStep: (labelText: string, transportMethod: string, item: IMoveTrackerStatus, notApplicableTransportList: string[]): IStep => {
        var label = (notApplicableTransportList.includes(transportMethod) ? "N/A" : labelText);
        var { fillColor, textColor, badgeColor } = Helper.getStatusColor(item.status, item.complete);

        return { labelText, label, overage: item.overage, textColor, fillColor, badgeColor, status: item.status, isComplete: item.complete };
    }
}